import el from "@cypherpotato/el";
import { Button, PrimaryButton } from "../components/button";
import { FormControl } from "../components/form";
import { Section } from "../components/layout";
import { cond } from "../util";
import { Icon } from './../components/icon';

function fancyShowDialog(dialog) {
    dialog.showModal();
    setTimeout(() => {
        dialog.classList.add("visible");
    }, 1);
    dialog.dismiss = fancyCloseDialog.bind(null, dialog);
}

function fancyCloseDialog(dialog) {
    dialog.classList.remove("visible");
    setTimeout(() => {
        dialog.remove();
    }, 250);
}

export function displayAlert({ title, message, type, buttons, dialogSize }) {
    const dialog = el("dialog.dialog-base",
        {
            classList: ["alert-dialog", type, dialogSize]
        },
        el(".dialog-header",
            el("div", title || "Alert"),
            el("button", Icon("close-line"), {
                onClick() {
                    dialog.dismiss();
                }
            })
        ),
        el(".dialog-body",
            cond(
                [type === "alert-warning", Icon("error-warning-line")],
                [type === "alert-info", Icon("information-2-line")],
            ),
            el(".message", message)
        ),
        buttons && el("menu.dialog-buttons",
            buttons.map(
                (args) =>
                    el(
                        "button.app-button",
                        args?.label,
                        {
                            onClick(event) {
                                event.target.closest("dialog").dismiss();
                            }
                        },
                        args
                    ))
        )
    );

    document.body.insertBefore(dialog, document.body.firstChild);
    fancyShowDialog(dialog);
}

export function displayFormControl({ title, message, formControlItem, onConfirm, validate, dialogSize, nullButton }) {

    const errorMessages = el.state.create([]);

    const dialog = el("dialog.dialog-base.form-control-dialog",
        {
            classList: [dialogSize]
        },
        el(".dialog-header",
            el("div", title || "Alert"),
            el("button", Icon("close-line"), {
                onClick() {
                    dialog.dismiss();
                }
            })
        ),
        el(".dialog-body",
            Section(
                el(".message", message),
            ),
            Section(
                FormControl(null,
                    formControlItem,
                    {
                        mount() {
                            formControlItem.focus();
                        }
                    }
                )
            ),
            Section(
                el.state.listening([errorMessages], () =>
                    el(".validation-error",
                        errorMessages.value.length > 0 && el("div", "Please correct the following errors before continuing."),
                        el("ul",
                            errorMessages.value.map(m =>
                                el("li", m)
                            )
                        )
                    )
                )
            )
        ),
        el("menu.dialog-buttons",
            nullButton && Button(
                "Set as empty",
                {
                    async onClick() {
                        await onConfirm(null);
                        dialog.dismiss();
                    },
                    style: {
                        marginRight: "auto"
                    }
                }
            ),
            PrimaryButton(
                "OK",
                {
                    onClick() {
                        const value = formControlItem.value;
                        if (validate) {
                            errorMessages.value = validate.map(([validateFn, errorMessage]) => {
                                if (!validateFn(value)) {
                                    return errorMessage;
                                }
                            }).filter(m => m != null);
                            if (errorMessages.value.length > 0) {
                                return;
                            }
                        }
                        onConfirm(value);
                        dialog.dismiss();
                    }
                }
            ),
            Button(
                "Cancel",
                {
                    onClick() {
                        dialog.dismiss();
                    }
                }
            )
        )
    );

    document.body.insertBefore(dialog, document.body.firstChild);
    fancyShowDialog(dialog);
}